import styled from 'styled-components';
import { H1 } from '../../style/typography';
import { min } from '../../lib/responsive';
import { HorizontalRedLines } from '../../lib/shared';

const AboutHeader = styled(H1)`
  margin-top: -1.05em;
  font-size: clamp(3em, 13.5vw, 6em);
  z-index: -1;
  @media ${min.tablet} {
    font-size: clamp(4em, 9.5vw, 9em);
  }
`;

const AboutHeaderDesktop = styled(AboutHeader)`
  display: none;
  @media ${min.tablet} {
    display: block;
  }
`;

const AboutHeaderMobile = styled(AboutHeader)`
  @media ${min.tablet} {
    display: none;
  }
`;

const AboutHeaderContainer = styled.div`
  padding-top: 14rem;
  transform: rotate(-3.38deg);
  z-index: -1;
  padding-left: 1rem;
  @media ${min.mobile} {
    padding-left: 1.5rem;
  }
  @media ${min.tabletSm} {
    padding-top: 15rem;
    padding-left: 4rem;
  }
  @media ${min.tablet} {
    padding-top: 17rem;
    padding-left: 5rem;
  }
  @media ${min.tabletLg} {
    padding-top: 20rem;
    padding-left: 10rem;
  }
  @media ${min.desktop} {
    padding-left: 13.5rem;
  }
`;

const SpeakerImg = styled.img`
  position: absolute;
  left: -1.5rem;
  z-index: -3;
  width: 7rem;
  top: 17rem;
  @media ${min.tabletSm} {
    width: 10rem;
  }
  @media ${min.tablet} {
    top: 16rem;
    width: 13rem;
    z-index: 1;
  }
  @media ${min.tabletLg} {
    width: 18rem;
  }
  @media ${min.desktop} {
    width: 22.5rem;
  }
`;

const YellowCirclesImg = styled.img`
  position: absolute;
  z-index: -2;
  width: 6rem;
  top: 20rem;
  right: 3rem;
  @media ${min.mobile} {
    right: 5rem;
  }
  @media ${min.tabletSm} {
    width: 10rem;
    top: 23rem;
  }
  @media ${min.tablet} {
    left: 29rem;
    width: 12rem;
    top: 19rem;
  }
  @media ${min.tabletLg} {
    left: 40rem;
    width: 18rem;
    top: 21rem;
  }
  @media ${min.desktop} {
    left: 51rem;
    width: 21rem;
    top: 23rem;
  }
`;

const AboutHorizontalRedLines = styled(HorizontalRedLines)`
  top: 16rem;
  display: block;
  @media ${min.desktop} {
    top: 19rem;
  }
  @media ${min.desktopLg} {
    top: 15rem;
  }
  @media ${min.desktopXlg} {
    display: none;
  }
`;

const AboutHorizontalRedLinesXl = styled(HorizontalRedLines)`
  display: none;
  @media ${min.desktopXlg} {
    display: block;
  }
`;

export {
  AboutHeader,
  AboutHeaderContainer,
  SpeakerImg,
  YellowCirclesImg,
  AboutHeaderDesktop,
  AboutHeaderMobile,
  AboutHorizontalRedLines,
  AboutHorizontalRedLinesXl,
};
